export class UnifiedRestoreWorkload {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "available",
            "baseName": "available",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return UnifiedRestoreWorkload.attributeTypeMap;
    }
    constructor() {
    }
}
